import * as actionType from './actionTypes';

const initialState = {};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.SET_USER:
      return action.payload;
    case actionType.CLEAR_USER:
      return {};
    case actionType.SET_USER_OPTION:
      return { ...state, user: action.payload };
    default:
      return state;
  }
};

export default reducer;
